<template>
    <div class="list-wrap">
        <div class="cnt"><span>{{total}}</span>건의 공지사항</div>
        <div class="list">
            <div class="content" v-for="board in boardData" :key="`board${board.wr_id}`" @click="goDetail(board.wr_id)">
                <div class="title">{{board.wr_subject}}</div>
                <div class="date">{{returnDate(board.wr_datetime)}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "@/utils/event-bus";
    export default {
        name: "BoardListDefaultLayout",
        props: {
            boardData: {
                type: Array,
                default: () => {return []},
            },
            total: {
                type: Number,
                default: 0,
            },
            categorys: {
                type: Array,
                default: () => {return []},
            },
        },
        data() {
            return {

            }
        },
        computed: {

        },
        mounted() {

        },
        methods: {
            returnDate(date) {
                if(!date) {
                    return '';
                }
                return this.$moment(date).format('YYYY-MM-DD HH:mm');
            },
            returnIndex(index) {
                return this.total - index;
            },
            goDetail(idx) {
                // EventBus.$emit('boardGoDetail', idx)
                this.$router.push(`/notice/${idx}`)
            },
        },
    }
</script>

<style scoped>

</style>